// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aneybxvzkmrcmvlhkyhv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFuZXlieHZ6a21yY212bGhreWh2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg1NTI0NzMsImV4cCI6MjA3NDEyODQ3M30.-eYLoK_5_MQSp7olGvsBqGTZCXnGe9nHn4ZWjqUzNAY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});